module.exports = __webpack_public_path__ + "img/GLP.1ebb31a5.svg";